import type { Socket } from 'socket.io-client';
import { tokenManager } from '@/lib/session/token.manager';

/* Il token viaggia anche nella query dell'handshake, non solo in `auth`.
 *
 * `auth` lo legge il servizio, ma arriva dopo l'upgrade: il gateway, che decide
 * se aprire il canale, a quel punto ha gia' risposto. Nella query lo vede
 * prima, applica le regole per utente e chiude la porta a una sessione
 * revocata. Lo toglie lui stesso prima di inoltrare. */
export const applyHandshakeToken = (socket: Socket): void => {
    const options = socket?.io?.opts;
    if (!options) return;

    const token = tokenManager.get();
    const query = { ...(options.query ?? {}) } as Record<string, unknown>;

    if (token) query.access_token = token;
    else delete query.access_token;

    options.query = query as never;
};

export default applyHandshakeToken;
